<!--FastBI产品-->
<template>
  <div class="home-main service clearfix">
    <div class="main" v-loading="loading">
      <div class="main_title">
        <span class="title-cn">产品应用</span> <span class="title-en">/Suite Products</span>
        <div class="main-title-right" v-loading="loading">
          <el-button size="medium" class="danger" @click="triallDialogOpen">应用试用</el-button>
          <el-button size="medium" class="primary" @click="buyFirstDialogOpen">申请购买</el-button>
        </div>
      </div>
      <!--筛选部分start-->
      <div class="product-selector">
        <div class="selector-left">
          <div class="block">
            <span class="demonstration">开通时间</span>
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="searchOption.openingDateStart"
              type="date"
              align="right"
              :picker-options="pickerOptions1"
              size="small"
            >
            </el-date-picker>
          </div>
          <div class="block">
            <span class="demonstration">到</span>
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="searchOption.openingDateEnd"
              type="date"
              align="right"
              :picker-options="pickerOptions2"
              size="small"
            >
            </el-date-picker>
          </div>
          <div class="block" v-if="isMaintainer()" >
            <span class="demonstration">伙伴用户名</span>
            <el-input v-model="searchOption.username" style="width: 200px;" size="small" clearable></el-input>
          </div>
        </div>
        <div class="selector-center">
          <div class="group">
            <p>授权码</p>
            <el-input v-model="searchOption.code" size="small" clearable></el-input>
          </div>
          <div class="group">
            <p>客户名称</p>
            <el-input v-model="searchOption.customerName" size="small" clearable></el-input>
          </div>
        </div>
        <div class="selector-right">
          <el-button size="small" class="warning" @click="search">搜索</el-button>
          <el-button size="small" @click="restSearch">重置</el-button>
        </div>
      </div>
      <!--筛选部分end-->

      <div class="product-main-line"></div>

      <!--产品列表start-->
      <div class="product-main-list">
        <el-table :data="tableData" height="100%" style="width:100%;" stripe>
          <el-table-column width="20"> </el-table-column>
          <el-table-column label="应用名称">
            <template slot-scope="scope">
              <span>{{ scope.row.suit_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="应用版本">
            <template slot-scope="scope">
              <span>{{ scope.row.suit_version }}</span>
            </template>
          </el-table-column>
          <el-table-column label="授权码">
            <template slot-scope="scope">
              <span>{{ scope.row.auth_code }}</span>
            </template>
          </el-table-column>
          <el-table-column label="授权客户名称">
            <template slot-scope="scope">
              <span>{{ scope.row.auth_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="归属伙伴用户名">
            <template slot-scope="scope">
              <span>{{ scope.row.user_loginname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="归属伙伴名称">
            <template slot-scope="scope">
              <span>{{ scope.row.user_company }}</span>
            </template>
          </el-table-column>
          <el-table-column label="开通时间">
            <template slot-scope="scope">
              <span>{{ scope.row.create_time }}</span>
            </template>
          </el-table-column>
          <el-table-column label="过期时间">
            <template slot-scope="scope">
              <span>{{ scope.row.expire_time }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span>{{ getAuthStatus(scope.row.status) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="400" class="table-status">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 3">
                <el-button size="mini" type="primary" @click="renewOpen(scope.$index, scope.row)">购买</el-button>
                <el-button
                  v-if="isShowDelayBtn(scope.$index, scope.row)"
                  size="mini"
                  type="primary"
                  @click="delay(scope.$index, scope.row)"
                  >延期</el-button
                >
                <el-button v-if="is_superuser" size="mini" type="primary" @click="delayClick(scope.$index, scope.row)"
                  >试用延期</el-button
                >
              </span>
              <span v-if="scope.row.status != 3">
                <template v-if="scope.row.fbi_edition == null">
                  <el-button
                    v-if="scope.row.expire_time != '买断'"
                    size="mini"
                    type="primary"
                    @click="renewOpen(scope.$index, scope.row)"
                    >续费</el-button
                  >
                </template>
              </span>
              <el-button size="mini" type="primary" @click="certificateOpen(scope.$index, scope.row)"
                >授权证书</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--产品列表end-->
      <div class="pagination">
        <el-pagination
          :disabled="!pagination.use"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
      <!--应用试用弹窗start-->
      <el-dialog
        :before-close="restTriallForm"
        title="申请试用应用模块"
        :visible.sync="triallDialog"
        width="506px"
        class="triallDialog"
      >
        <el-form :model="triallForm" ref="triallForm" :rules="triallFormRules">
          <el-form-item label="绑定授权码" prop="auth_code" :label-width="formLabelWidth">
            <el-input v-model="triallForm.auth_code" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="增购应用名称" prop="suit" :label-width="formLabelWidth">
            <el-select v-model="triallForm.suit" placeholder="请选择" @change="selectChange">
              <el-option v-for="(item, key) in suit" :key="key" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="试用时长" :label-width="formLabelWidth">
            <el-select v-model="triallForm.trail_days" placeholder="请选择">
              <el-option v-for="item in triallDate" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel('triallForm', (triallDialog = false))">取 消</el-button>
          <el-button class="primary" @click="triallFormSubmit">提 交</el-button>
        </div>
      </el-dialog>
      <!--应用试用弹窗end-->

      <!--申请购买弹窗start-->
      <el-dialog
        :before-close="restbuyFirstForm"
        title="增购应用模块"
        :visible.sync="buyFirstDialog"
        width="506px"
        class="buyFirstDialog"
      >
        <el-form v-if="!payTableShow" :model="buyFirstForm" ref="buyFirstForm" :rules="buyFirstFormRules">
          <el-form-item label="绑定授权码" prop="auth_code" :label-width="formLabelWidth">
            <el-input v-model="buyFirstForm.auth_code" autocomplete="off"> </el-input>
          </el-form-item>
          <el-form-item label="增购应用名称" prop="suit" :label-width="formLabelWidth">
            <el-select v-model="buyFirstForm.suit" placeholder="请选择" @change="selectChange">
              <el-option v-for="(item, key) in suit" :key="key" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="购买时长" :label-width="formLabelWidth">
            <el-select v-model="buyFirstForm.months" placeholder="请选择">
              <el-option v-for="item in buyDate" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="支付方式" :label-width="formLabelWidth">
            <el-radio-group v-model="buyFirstForm.pay_type">
              <el-radio :label="1">FastBI产品专用币优先</el-radio>
              <el-radio :label="2">通用币优先</el-radio>
            </el-radio-group>
          </el-form-item> -->
        </el-form>
        <div v-if="payTableShow" class="clearfix">
          <el-table :data="payTableData" border style="width: 100%">
            <el-table-column prop="auth_code" label="绑定授权码" width="180"> </el-table-column>
            <el-table-column prop="auth_name" label="授权客户" width="80"> </el-table-column>
            <el-table-column prop="price" label="价格"> </el-table-column>
          </el-table>
          <el-alert class="alert" title="支付描述" :type="alertType" :closable="false" :description="payDescription">
          </el-alert>
          <el-button v-if="payBtnShow" class="primary pay_btn" @click="firstBuySure">确认支付</el-button>
        </div>
        <div v-if="!payTableShow" slot="footer" class="dialog-footer">
          <el-button @click="cancel('buyFirstForm', (buyFirstDialog = false))">取消购买</el-button>
          <el-button class="primary" @click="buyFirstSubmit">提交</el-button>
        </div>
      </el-dialog>
      <!--申请购买弹窗end-->

      <!--产品续费弹窗start-->
      <el-dialog
        :before-close="restRenewForm"
        title="购买应用"
        :visible.sync="renewDialog"
        width="506px"
        class="renewDialog"
      >
        <el-form v-if="!payTableShow" ref="renewForm" :rules="renewFormRules" :model="renewForm">
          <el-form-item label="绑定授权码" :label-width="formLabelWidth">
            <el-input v-model="renewForm.auth_code" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="授权客户名称" :label-width="formLabelWidth">
            <el-input v-model="renewForm.auth_name" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="应用" :label-width="formLabelWidth">
            <el-input v-model="renewForm.suit_name" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="购买时长" :label-width="formLabelWidth">
            <el-select v-model="renewForm.months" placeholder="请选择">
              <el-option v-for="item in buyDate" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="支付方式" :label-width="formLabelWidth">
            <el-radio-group v-model="renewForm.pay_type">
              <el-radio :label="1">FastBI产品专用币优先</el-radio>
              <el-radio :label="2">通用币优先</el-radio>
            </el-radio-group>
          </el-form-item> -->
        </el-form>
        <div v-if="payTableShow" class="clearfix">
          <el-table :data="payTableData" border style="width: 100%">
            <el-table-column prop="auth_code" label="绑定授权码" width="180"> </el-table-column>
            <el-table-column prop="auth_name" label="授权客户名称" width="80"> </el-table-column>
            <el-table-column prop="price" label="价格"> </el-table-column>
          </el-table>
          <el-alert class="alert" title="支付描述" :type="alertType" :closable="false" :description="payDescription">
          </el-alert>
          <el-button v-if="payBtnShow" class="primary pay_btn" @click="renewPay">确认支付</el-button>
        </div>
        <div v-if="!payTableShow" slot="footer" class="dialog-footer">
          <el-button @click="cancel('renewForm', (renewDialog = false))">取 消</el-button>
          <el-button class="primary" @click="renewSubmit">提 交</el-button>
        </div>
      </el-dialog>
      <!--产品续费弹窗end-->

      <!--授权证书start-->
      <el-dialog title="授权证书" :visible.sync="certificateDialog" width="510px">
        <img :src="certificateUrl" alt="" width="100%" />
        <div slot="footer" class="dialog-footer">
          <el-button class="primary" @click="certificateDialog = false">关闭</el-button>
        </div>
      </el-dialog>
      <!--授权证书end-->

      <extensionDialog ref="extensionDialog"></extensionDialog>
    </div>
  </div>
</template>

<script>
import { isvalidPhone } from '@/assets/js/validate';
import { getSuit, getSuitAuthParam, buy, buyPrice, trail, getCertificateById, trialDelay } from '@/api/suit';
import { createGetUrlParams } from '@/utils/url';
import { authStatus, payType } from '@/utils/dataDict';
import { payVerify } from '@/utils/pay';
import extensionDialog from './dialog/extensionDialog';
export default {
  data() {
    //手机号验证
    let validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入电话号码'));
      } else if (!isvalidPhone(value)) {
        callback(new Error('请输入正确的11位手机号码'));
      } else {
        callback();
      }
    };
    //两次密码是否相等
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.changKeyForm.newPassword) {
        callback(new Error('两次输入密码请保持一致!'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      verifyCodeResult: {
        //接收效验code是否已存在结果
        success: false,
        loading: false,
        icon: '',
      },
      pagination: {
        use: true,
        total: 0,
        size: 20,
        currentPage: 1,
      },
      suit: [], //应用
      codeLoading: false,
      curentId: 0, //选中表格行的id
      currentIndex: 0, //选中表格行的元素下标
      payTableShow: false,
      payTableData: [], //支付所需价格表
      payData: '', //需要支付的数据
      payBtnShow: false,
      alertType: 'success',
      payDescription: '',
      /*筛选条件*/
      searchOption: {
        openingDateStart: '', //选择开通时间-开始
        openingDateEnd: '', //选择开通时间-结束
        expirationDateStart: '', //选择过期时间-开始
        expirationDateEnd: '', //选择过期时间-结束
        customerName: '', //选择授权客户
        code: '', //选择授权码
        username:""
      },

      /*开通时间start*/
      pickerOptions1: {
        shortcuts: [
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 1);
              picker.$emit('pick', date);
            },
          },
          {
            text: '最近7天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
          {
            text: '最近30天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            },
          },
          {
            text: '最近90天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', date);
            },
          },
          {
            text: '最近1年',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit('pick', date);
            },
          },
        ],
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            },
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            },
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
        ],
      },
      /*开通时间end*/

      /*过期时间start*/
      pickerOptions3: {
        shortcuts: [
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 1);
              picker.$emit('pick', date);
            },
          },
          {
            text: '最近7天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
          {
            text: '最近30天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            },
          },
        ],
      },
      pickerOptions4: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            },
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            },
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
          {
            text: '一周后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
          {
            text: '30天后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            },
          },
        ],
      },
      /*过期时间end*/

      /*表格数据start*/
      tableData: [],
      /*表格数据end*/

      formLabelWidth: '110px',

      /*应用试用start*/
      triallDialog: false,
      FBITriallDateValue: '',
      triallForm: {
        auth_code: '', //试用产品授权码
        trail_days: 30,
        suit: '',
      },
      triallFormRules: {
        auth_code: [
          {
            required: true,
            message: '请输入授权码',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: '只支持输入数字、字母',
            trigger: 'blur',
          },
        ],
        suit: [
          {
            required: true,
            message: '请选择应用',
            trigger: 'blur',
          },
        ],
      },
      triallDate: [
        {
          value: 7,
          label: '七天',
        },
        {
          value: 15,
          label: '十五天',
        },
        {
          value: 30,
          label: '一个月',
        },
      ],
      /*应用试用end*/

      /*申请购买产品start*/
      buyFirstDialog: false,
      buyFirstForm: {
        auth_code: '', //产品授权码
        suit: '',
        pay_type: 1,
        months: null,
      },
      buyFirstFormRules: {
        auth_code: [
          {
            required: true,
            message: '请输入授权码',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: '只支持输入数字、字母',
            trigger: 'blur',
          },
        ],
        suit: [
          {
            required: true,
            message: '请选择应用',
            trigger: 'blur',
          },
        ],
      },
      buyDate: [
        {
          value: 12,
          label: '一年',
        },
        {
          value: 24,
          label: '两年',
        },
        {
          value: 36,
          label: '三年',
        },
        {
          value: 1200,
          label: '买断',
        },
      ],
      /*申请购买产品end*/

      /*产品续费start*/
      renewDialog: false,
      renewForm: {
        auth_code: '', //产品授权码
        auth_name: '', //授权客户名称
        suit_name: '',
        suit: '',
        pay_type: 1,
        months: null,
      },
      renewFormRules: {
        months: [
          { required: true, message: '请输入新增用户数', trigger: 'blur' },
          { type: 'number', message: '请输入数字' },
        ],
      },
      /*产品续费end*/

      /*显示授权证书 start*/
      certificateDialog: false,
      certificateUrl: '',
      is_superuser: false,
      /*显示授权证书 end*/
    };
  },
  components: {
    extensionDialog,
  },
  mounted() {
    this.getSuitAuthData();
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      const res = await this.$store.dispatch('user/userinfo');
      this.is_superuser = res.is_superuser;
    },
    selectChange(val) {
      this.suit.forEach((item) => {
        console.log(item);
        if (item.id == val) {
          if (item.buyout_valid && item.valid) {
            this.buyDate = [
              {
                value: 12,
                label: '一年',
              },
              {
                value: 24,
                label: '两年',
              },
              {
                value: 36,
                label: '三年',
              },
              {
                value: 1200,
                label: '买断',
              },
            ];
          } else if (item.buyout_valid) {
            this.buyDate = [
              {
                value: 1200,
                label: '买断',
              },
            ];
          } else if (item.valid) {
            this.buyDate = [
              {
                value: 12,
                label: '一年',
              },
              {
                value: 24,
                label: '两年',
              },
              {
                value: 36,
                label: '三年',
              },
            ];
          }
          // this.charge_type = item.charge_type;
          // this.edition = item.editions || [];
        }
      });
    },
    isShowDelayBtn(index, row) {
      return new Date(row.expire_time) < new Date(); //过期时间小于当前时间
    },
    delay(index, row) {
      let self = this;
      this.$confirm('您将对授权码进行延期操作，是否继续进行？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.loading = true;
          trialDelay(row.id)
            .then((response) => {
              self.loading = false;
              self.$message.success('延期成功!');
              self.getSuitAuthData();
            })
            .catch(() => {
              self.loading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    delayClick(index, row) {
      this.$refs.extensionDialog.show();
      this.$refs.extensionDialog.initData(row, 'suit');
    },
    getPayType(val) {
      return payType[val];
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getSuitAuthData();
    },
    handleSizeChange(val) {
      if (val <= this.pagination.total) {
        this.pagination.size = val;
        this.getSuitAuthData();
      }
    },
    search() {
      this.restPage(true);
      let params = {
        date_start: this.searchOption.openingDateStart,
        date_stop: this.searchOption.openingDateEnd,
        auth_name: this.searchOption.customerName,
        auth_code: this.searchOption.code,
        username: this.searchOption.username,
      };
      let result = createGetUrlParams(params);

      if (result.success) {
        this.loading = true;
        getSuitAuthParam(result.data)
          .then((response) => {
            this.tableData = response.results;
            this.pagination.total = response.count;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    restSearch() {
      for (const key in this.searchOption) {
        if (this.searchOption.hasOwnProperty(key)) {
          this.searchOption[key] = '';
        }
      }
      this.restPage(true);
      this.getSuitAuthData();
    },
    restPage(isUsePagination) {
      this.pagination.use = isUsePagination;
      this.pagination.currentPage = 1;
      this.pagination.size = 20;
    },
    getSuitData() {
      //获取应用列表
      this.loading = true;
      getSuit()
        .then((response) => {
          this.loading = false;
          this.suit = response;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getSuitAuthData() {
      //获取应用用户列表
      this.loading = true;
      let params = {
        p: this.pagination.currentPage,
        count: this.pagination.size,
      };
      let result = createGetUrlParams(params);
      if (result.success) {
        getSuitAuthParam(result.data)
          .then((response) => {
            this.loading = false;
            this.pagination.total = response.count | 0;
            this.tableData = response.results;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    isMaintainer(){
      // return false
      if(this.$store.getters.userInfo){
        if(this.$store.getters.userInfo.is_superuser) return true
        return this.$store.getters.userInfo.is_maintainer
      }
      return false
    },
    getAuthStatus(index) {
      return authStatus[index];
    },
    triallDialogOpen() {
      this.suit = '';
      this.getSuitData();
      this.triallForm.trail_days = 30;
      this.triallDialog = true;
    },
    triallFormSubmit() {
      //申请试用
      this.$refs.triallForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          trail(this.triallForm)
            .then(() => {
              this.loading = false;
              this.$message({
                type: 'success',
                message: '申请试用成功',
              });
              this.getSuitAuthData();
              this.triallDialog = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    restTriallForm(done) {
      if (this.$refs.triallForm) this.$refs.triallForm.resetFields();
      done();
    },
    renewOpen(index, row) {
      //续费
      this.buyDate = [
        {
          value: 12,
          label: '一年',
        },
        {
          value: 24,
          label: '两年',
        },
        {
          value: 36,
          label: '三年',
        },
        {
          value: 1200,
          label: '买断',
        },
      ];
      this.payTableShow = false;
      this.curentId = row.id;
      this.renewForm.auth_code = row.auth_code;
      this.renewForm.auth_name = row.auth_name;
      this.renewForm.suit_name = `${row.suit_name}`;
      this.renewForm.suit = row.suit;
      this.renewDialog = true;
    },
    renewSubmit() {
      this.$refs.renewForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let data = {
            suit: this.renewForm.suit,
            auth_code: this.renewForm.auth_code,
            pay_type: this.renewForm.pay_type,
            months: this.renewForm.months,
          };
          buyPrice(data)
            .then((response) => {
              this.payTableData[0] = response;
              this.payTableShow = true;

              this.$store
                .dispatch('user/userinfo') //获取账户余额
                .then(() => {
                  let finance = {
                    special: this.$store.getters.userInfo.finance.fbi_point,
                    universal: this.$store.getters.userInfo.finance.point,
                  };
                  let parms = {
                    price: response.price,
                    payType: this.renewForm.pay_type,
                  };
                  let result = payVerify(parms, finance, 'FastBI产品'); //检测余额是否足够
                  this.payDescription = result.msg;
                  this.payBtnShow = result.success;

                  if (result.success) {
                    //余额充足
                    this.payData = data;
                    this.alertType = 'success';
                  } else {
                    //余额不足
                    this.alertType = 'error';
                  }
                  this.loading = false;
                })
                .catch(() => {
                  this.loading = false;
                });
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    renewPay() {
      this.loading = true;
      buy(this.payData)
        .then((response) => {
          this.loading = false;
          this.$message({
            type: 'success',
            message: '支付成功',
          });
          this.getSuitAuthData();
          this.renewDialog = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    restRenewForm(done) {
      if (this.$refs.renewForm) this.$refs.renewForm.resetFields();
      done();
    },
    buyFirstDialogOpen() {
      //申请购买
      this.payTableShow = false;
      this.buyFirstForm.suit = '';
      this.getSuitData();
      this.buyFirstDialog = true;
    },
    buyFirstSubmit() {
      this.$refs.buyFirstForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          buyPrice(this.buyFirstForm)
            .then((response) => {
              //获取此次充值的价格
              this.payTableData[0] = response;
              this.payTableShow = true;
              this.$store
                .dispatch('user/userinfo') //获取账户余额
                .then(() => {
                  this.loading = false;
                  let finance = {
                    special: this.$store.getters.userInfo.finance.fbi_point,
                    universal: this.$store.getters.userInfo.finance.point,
                  };
                  let parms = {
                    price: response.price,
                    payType: this.buyFirstForm.pay_type,
                  };

                  let result = payVerify(parms, finance, 'FastBI产品'); //检测余额是否足够
                  this.payDescription = result.msg;
                  this.payBtnShow = result.success;

                  if (result.success) {
                    //余额充足
                    this.payData = data;
                    this.alertType = 'success';
                  } else {
                    //余额不足
                    this.alertType = 'error';
                  }
                })
                .catch(() => {
                  this.loading = false;
                });
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    firstBuySure() {
      this.loading = true;
      buy(this.buyFirstForm)
        .then((response) => {
          this.loading = false;
          this.$message({
            type: 'success',
            message: '支付成功',
          });
          this.getSuitAuthData();
          this.buyFirstDialog = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    restbuyFirstForm(done) {
      if (this.$refs.buyFirstForm) this.$refs.buyFirstForm.resetFields();
      done();
    },
    cancel(formName, close) {
      this.$refs[formName].resetFields();
    },
    certificateOpen(index, row) {
      //显示授权证书
      this.certificateUrl = '';
      this.loading = true;
      getCertificateById(row.id)
        .then((response) => {
          this.certificateUrl = response.url;
          this.loading = false;
          this.certificateDialog = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import url('../../assets/css/product.css');

.service {
  .main {
    display: flex;
    flex-direction: column;
    margin: 0px 14px;
    height: 100%;
    //background-color: #FFFFFF;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;

    .main_title {
      margin: 15px 0;
    }

    .product-selector {
      width: 100%;
      //height: 37px !important;
      background: #fff;

      .selector-center {
        margin-left: 0 !important;
        width: 400px !important;
      }
    }

    .group {
      p {
        margin: 10px 15px 10px 5px !important;
        float: left !important;
        width: 50px !important;
        height: 32px !important;
        line-height: 32px !important;
        text-align: right !important;
      }
    }

    .group .el-input {
      float: left !important;
      margin: 10px 0px !important;
      width: 120px !important;
    }

    .product-main-list {
      flex-grow: 1;
      height: 50%;
    }

    .selector-right {
      height: 100% !important;
      line-height: 50px !important;
    }
  }

  .alert {
    margin-bottom: 10px;
  }

  .pay_btn {
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/Suite.vue